// Thin Cleanup wrapper around the existing MoveRecordHouseholdModal
// (search → pick destination household → pick a reason code → move).
//
// Resolves the `move-household` recommendation, which had no decide-rail
// handling at all: the rail POSTed the verb to POST /api/cleanup/decide,
// which has no case for it, so the recommended button returned 501
// `verb_not_wired`. See record-move-predicate.ts for the full account.
//
// Deliberately thinner than CleanupContactMoveOverlay, which has to fetch
// a whole SafeContact before its modal can open. Everything this modal
// needs — the record's kind, id, label, and the household it sits on — is
// already on the cleanup issue, so there is nothing to load and no
// loading or error state to render. The modal owns the reason picker, the
// POST, and the success toast with its one-click Undo.

import { MoveRecordHouseholdModal } from "../components/MoveRecordHouseholdModal";
import type { RecordMoveTarget } from "./record-move-predicate";

export function CleanupRecordMoveOverlay({
  target,
  onClose,
  onMoved,
}: {
  target: RecordMoveTarget;
  onClose: () => void;
  onMoved: () => void;
}) {
  return (
    <MoveRecordHouseholdModal
      recordKind={target.recordKind}
      recordId={target.record.id}
      recordLabel={target.record.label}
      currentHouseholdId={target.currentHouseholdId}
      onClose={onClose}
      onMoved={() => onMoved()}
    />
  );
}
